<template>
  <div class="ine-form__submit-btn-wrapper">
    <button
      v-if="!isLoading"
      class="btn__auth ine-form__submit-btn"
      type="submit"
    >
      <span class="material-icons btn__auth--icon ine-form__submit-btn--icon">{{
        iconName
      }}</span>
      {{ title }}
    </button>
    <ActionLoader
      v-else
      loaderClass="ine-form__loading-spinner"
      name="ball-clip-rotate"
    />
  </div>
</template>

<script>
import ActionLoader from '@/components/shared/ActionLoader.vue'

export default {
  name: 'SubmitBtn',
  components: {
    ActionLoader,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    iconName: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
